import { create, useModal } from '@ebay/nice-modal-react';
import Popup from '@shared/components/Popup/Popup';
import { useTranslation } from 'react-i18next';

import MarkAllAsReadButton from './MarkAllAsReadButton';
import NotificationsList from './NotificationsList/NotificationsList';

const NotificationsMobileModal = create(() => {
  const { t } = useTranslation();
  const { remove } = useModal(NotificationsMobileModal);

  return (
    <Popup closePopup={remove} isVisible isDesktopViewportScrollable isPartial>
      <Popup.FullScreenContainer className="md:w-[512px]">
        <Popup.Header className="shadow-none justify-between px-4 flex-wrap">
          <span className="font-medium text-black">{t('notifications_label')}</span>
          <MarkAllAsReadButton onClick={remove} />
        </Popup.Header>
        <NotificationsList />
      </Popup.FullScreenContainer>
    </Popup>
  );
});

export default NotificationsMobileModal;
